import { RootState } from "../../rootState";
import { CHANGE_MAP_VIEW } from "../../../MapStore2/web/client/actions/map";
import { queryableLayersSelector } from "../../common/selector/layerSelector";
import { doNothingAction } from "../../common/action/doNothingAction";
import { selectedFeaturesFromPortalSelector, selectedFeaturesSelector } from "../../common/selector/featuresSelector";
import { Feature } from "../../core/geo/types";
import { applyHighlightLayersAction } from "../action/applyHighlightLayersAction";

const getFeaturesLayerNames = (features: Feature[]) => {
    return features.map((feature: Feature) => feature.properties.layer);
};
const zoomOutHighlightLayerEpic = (action$: any, store: any) =>
    action$.ofType(CHANGE_MAP_VIEW).map(() => {
        const state: RootState = store.getState();
        const selectedFeaturesFromPortalLayers = getFeaturesLayerNames(
            selectedFeaturesFromPortalSelector(store.getState()) ?? []
        );
        const selectedFeaturesLayers = getFeaturesLayerNames(selectedFeaturesSelector(store.getState()) ?? []);
        const queryableLayerNames = queryableLayersSelector(state).map((layer) => layer.name);

        const notVisibleSelectedLayers = [...selectedFeaturesLayers, ...selectedFeaturesFromPortalLayers].filter(
            (featureName: string | undefined) => !queryableLayerNames.includes(featureName)
        );

        if (
            (store.getState().highlight && store.getState().highlight.baselineLayer) ||
            store.getState().highlight.workspaceLayer
        ) {
            const baselineUpdated = store.getState().highlight.baselineLayer;
            const workspaceUpdated = store.getState().highlight.workspaceLayer;
            if (baselineUpdated) {
                baselineUpdated.visibility = notVisibleSelectedLayers.length <= 0;
            }
            if (workspaceUpdated) {
                workspaceUpdated.visibility = notVisibleSelectedLayers.length <= 0;
            }
            return applyHighlightLayersAction(baselineUpdated, workspaceUpdated);
        }

        return doNothingAction();
    });

export default zoomOutHighlightLayerEpic;
